export default __webpack_public_path__ + "static/media/search-icon.9ca6b7b3.svg";